define(['modules/common/controls/control', 'utils/search/filterSearch'], (Control, filterSearch) => Control.extend({

    tagName: 'input',
    attributes: {type: 'text'},
    wait: 750,
    captureLength: -1,

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    let val = view.$el.val();
                    if (view.options.cleardanglingspaces) {
                        val = filterSearch.default(val);
                    }
                    publish(val);
                };
                view.$el.typeWatch({wait: view.wait, captureLength: view.captureLength, callback: this.callback});
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.$el.val(value);
            }
        },
        enabled (view, value) {
            view.$el.attr('disabled', !value);
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        }
    }

}));
